module.exports = __webpack_public_path__ + "static/media/product-placeholder.3a73290c.svg";